import { defineComponent as p, ref as u, resolveComponent as f, openBlock as c, createElementBlock as g, createVNode as w, withCtx as T, createElementVNode as v, normalizeStyle as A, normalizeClass as E, renderSlot as I, createBlock as L, createCommentVNode as S } from "vue";
import x from "../../atoms/VNavigationArrows/VNavigationArrows.js";
import b from "../../atoms/VSliderPagination/VSliderPagination.js";
import { SpacingHobiVariable as W } from "../../../composables/useSpacingClass.js";
import { getComputedStyleValue as O } from "../../../utils/getComputedStyleValue.js";
import { _ as V } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../atoms/VIconButton/VIconButton.js";
import "../../atoms/VIcon/VIcon.js";
const M = p({
  name: "RSlider",
  components: { VNavigationArrows: x, VSliderPagination: b },
  props: {
    numberOfElementsToShow: {
      type: Number,
      default: 0,
      validator: (t) => t >= 0
    },
    startingIndex: {
      type: Number,
      default: 0,
      validator: (t) => t >= 0
    },
    slideStep: {
      type: Number,
      default: 1,
      validator: (t) => t >= 1
    },
    isInfinite: {
      type: Boolean,
      default: !1
    },
    showPaginator: {
      type: Boolean,
      default: !1
    },
    navigationArrowsAriaLabel: {
      type: String,
      default: null
    },
    withMarginOnSlides: {
      type: Boolean,
      default: !0
    },
    marginBetweenTiles: {
      type: String,
      default: W.m
    },
    marginBetweenTilesOnDesktop: {
      type: String,
      default: ""
    },
    showMarginOnFirstAndLastTile: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    activeIndex: 0,
    tileWidth: 0,
    tileMargin: 0,
    stepCounter: 0,
    isLastElementInFullView: !1,
    sliderViewport: 0,
    startX: 0,
    moveX: 0,
    windowWidth: window.innerWidth
  }),
  computed: {
    activeElement() {
      var t;
      return (t = this.slideList) == null ? void 0 : t.children[this.activeIndex];
    },
    totalTileWidth() {
      return this.tileWidth + this.tileMargin;
    },
    totalSlideListWidth() {
      const t = this.slideList ? this.totalTileWidth * this.slideList.children.length : 0, e = this.showMarginOnFirstAndLastTile ? this.tileMargin : 0;
      return this.slideList ? t + e : 0;
    },
    numberOfSlides() {
      var t;
      return (t = this.slideList) == null ? void 0 : t.children.length;
    },
    visibleTilesFullWidth() {
      const t = this.totalTileWidth * this.numberOfElementsToShow;
      return this.isNumberOfElementsToShowValid ? t : this.totalSlideListWidth;
    },
    cssVariable() {
      return {
        "--max-width": this.numberOfElementsToShow ? `${this.visibleTilesFullWidth}px` : `${this.totalSlideListWidth}px`,
        "--tile-margin": `${this.tileMargin}px`
      };
    },
    isStartingIndexValid() {
      return this.slideList ? this.startingIndex < this.slideList.children.length : !1;
    },
    isNumberOfElementsToShowValid() {
      return this.slideList ? this.numberOfElementsToShow <= this.slideList.children.length : !1;
    },
    previousActiveIndex() {
      return this.slideList && this.activeIndex - 1 < 0 ? this.slideList.children.length - 1 : this.activeIndex - 1;
    },
    numberOfVisibleElements() {
      return Math.floor(this.sliderViewport / this.totalTileWidth) || 1;
    },
    partialElementHiddenAmount() {
      const t = this.showMarginOnFirstAndLastTile ? this.tileMargin : this.tileMargin * -1;
      return this.totalTileWidth - (this.sliderViewport - this.totalTileWidth * this.numberOfVisibleElements) + t;
    },
    isFirstElementActive() {
      return this.activeIndex === 0;
    },
    isLastElementActive() {
      return this.slideList && this.previousActiveIndex + this.numberOfElementsToShow === this.slideList.children.length - 1;
    },
    areAllElementsVisible() {
      return this.slideList && this.numberOfVisibleElements === this.slideList.children.length;
    },
    shouldTranslatePrev() {
      return !this.areAllElementsVisible && (this.isInfinite || !this.isFirstElementActive);
    },
    shouldTranslateNext() {
      return !this.areAllElementsVisible && (this.isInfinite || this.numberOfElementsToShow > 0 && this.numberOfVisibleElements === this.numberOfElementsToShow && !this.isLastElementActive || !this.isLastElementInFullView);
    }
  },
  methods: {
    slide(t) {
      const e = t < 0, i = t > 0;
      this.slideList && (e && this.shouldTranslatePrev || i && this.shouldTranslateNext) && this.updateIndexAndTranslate(t), this.slideStep > 1 && this.slideAfterAnimation(t);
    },
    slideAfterAnimation(t) {
      if (this.slideList) {
        const { children: e } = this.slideList;
        Promise.all(
          e[this.activeIndex].getAnimations().map((i) => i.finished)
        ).then(() => {
          this.updateIndexAndTranslate(t), this.stepCounter += 1, this.stepCounter < this.slideStep - 1 ? this.slideAfterAnimation(t) : this.stepCounter = 0;
        });
      }
    },
    updateIndexAndTranslate(t) {
      this.slideList && (this.updateActiveIndex(t, this.slideList), this.translateElements(t));
    },
    updateActiveIndex(t, e) {
      const { children: i } = e, s = this.activeIndex + t, n = s === i.length, r = this.isFirstElementActive && t < 0;
      this.isInfinite ? n ? this.activeIndex = 0 : r ? this.activeIndex = i.length + t : this.activeIndex += t : s >= 0 && s < i.length && (this.activeIndex += t);
    },
    translateElements(t) {
      t > 0 ? this.next() : this.prev();
    },
    prev(t = !0) {
      if (this.slideList) {
        const { children: e } = this.slideList, i = e.length;
        for (let s = 0; s < i; s += 1) {
          const n = e[s], r = this.isInfinite && this.activeIndex === s, a = i * this.totalTileWidth * -1, o = i - 1 - this.activeIndex, l = this.calculateElementStartAmountPrev(
            i,
            o,
            s
          ), h = l + a, d = r ? h : l, m = this.calculateElementEndAmountPrev(d);
          r && this.translateElementToPrevious(h), t && n.animate(
            [
              { transform: `translateX(${d}px)` },
              { transform: `translateX(${m}px)` }
            ],
            { duration: 500 }
          ), n.style.transform = `translateX(${m}px)`;
        }
        this.isLastElementInFullView = !1;
      }
    },
    next(t = !0) {
      if (this.slideList) {
        const { children: e } = this.slideList, i = e.length, s = this.previousActiveIndex + this.numberOfVisibleElements === this.slideList.children.length - 1;
        this.isLastElementInFullView = s;
        for (let n = 0; n < i; n += 1) {
          const r = e[n], a = this.previousActiveIndex, o = this.calculateElementStartAmountNext(
            i,
            a,
            n
          ), l = this.calculateElementEndAmountNext(
            o,
            s
          ), h = i * this.totalTileWidth, d = l + h;
          t && r.animate(
            [
              { transform: `translateX(${o}px)` },
              { transform: `translateX(${l}px)` }
            ],
            { duration: 500 }
          ), r.style.transform = `translateX(${l}px)`, this.isInfinite && this.translateOnAnimationEnd(n, d);
        }
      }
    },
    calculateElementStartAmountPrev(t, e, i) {
      const s = e - t, n = this.totalTileWidth * s;
      let r = 0;
      return !this.isInfinite && this.isLastElementInFullView ? r = n + (this.totalTileWidth - this.partialElementHiddenAmount) : this.isInfinite && i <= this.activeIndex ? r = e * this.totalTileWidth : r = n, r;
    },
    calculateElementStartAmountNext(t, e, i) {
      let s = 0;
      return this.isInfinite && i < this.previousActiveIndex ? s = (t - e) * this.totalTileWidth : s = e * this.totalTileWidth * -1, s;
    },
    calculateElementEndAmountPrev(t) {
      let e = 0;
      return !this.isInfinite && this.numberOfElementsToShow === 0 && this.isLastElementInFullView ? e = t + this.partialElementHiddenAmount : e = t + this.totalTileWidth, e;
    },
    calculateElementEndAmountNext(t, e) {
      let i = 0;
      return !this.isInfinite && e ? i = t - this.partialElementHiddenAmount : i = t - this.totalTileWidth, i;
    },
    translateElementToPrevious(t) {
      if (this.slideList) {
        const e = this.slideList.children[this.activeIndex];
        e.style.transform = `translateX(${t}px)`;
      }
    },
    translateOnAnimationEnd(t, e) {
      if (this.slideList) {
        const { children: i } = this.slideList, s = i[t];
        Promise.all(
          i[this.activeIndex].getAnimations().map((n) => n.finished)
        ).then(() => {
          t === this.previousActiveIndex && (s.style.transform = `translateX(${e}px)`);
        });
      }
    },
    goToIndex(t) {
      if (this.slideList)
        if (this.activeIndex < t)
          for (let e = this.activeIndex; e < t; e += 1)
            this.updateActiveIndex(1, this.slideList), this.next(!1);
        else
          for (let e = this.activeIndex; e > t; e -= 1)
            this.updateActiveIndex(-1, this.slideList), this.prev(!1);
    },
    getSliderWidth() {
      this.slider && (this.sliderViewport = this.slider.offsetWidth);
    },
    getResponsiveTileMargins() {
      const t = window.innerWidth, e = this.marginBetweenTilesOnDesktop || this.marginBetweenTiles, i = t < 960 ? this.marginBetweenTiles : e;
      this.tileMargin = +O(
        i
      ).slice(0, -2);
    },
    onWindowResize() {
      this.getResponsiveTileMargins(), this.getSliderWidth(), this.updateTileWidth(), window.innerWidth !== this.windowWidth && this.isStartingIndexValid && !this.isInfinite && this.goToIndex(this.startingIndex);
    },
    updateTileWidth() {
      const t = this.activeElement.getBoundingClientRect().width;
      this.tileWidth = Math.round(t * 100) / 100;
    },
    handlePaginatorClick(t) {
      this.goToIndex(t);
    },
    touchStart(t) {
      this.startX = t.touches[0].clientX;
    },
    touchMove(t) {
      this.moveX = t.touches[0].clientX;
    },
    touchEnd() {
      this.startX + 100 < this.moveX ? this.slide(-1) : this.startX - 100 > this.moveX && this.slide(1);
    }
  },
  setup() {
    const t = u(null), e = u(null);
    return { slideList: t, slider: e };
  },
  mounted() {
    this.windowWidth = window.innerWidth, window.addEventListener("resize", this.onWindowResize), this.slideList && (this.getResponsiveTileMargins(), this.updateTileWidth(), this.isStartingIndexValid && this.goToIndex(this.startingIndex)), this.$nextTick(() => this.getSliderWidth());
  },
  unmounted() {
    window.removeEventListener("resize", this.onWindowResize);
  }
});
const P = { class: "hobi-slider-wrapper" };
function y(t, e, i, s, n, r) {
  const a = f("VNavigationArrows"), o = f("VSliderPagination");
  return c(), g("div", P, [
    w(a, {
      "show-left-arrow": t.shouldTranslatePrev && t.numberOfVisibleElements !== t.numberOfSlides,
      "show-right-arrow": t.shouldTranslateNext && t.numberOfVisibleElements !== t.numberOfSlides,
      "onNavigationArrows:clickLeft": e[3] || (e[3] = (l) => t.slide(-1)),
      "onNavigationArrows:clickRight": e[4] || (e[4] = (l) => t.slide(1)),
      navigationArrowsAriaLabel: t.navigationArrowsAriaLabel,
      isWrapper: ""
    }, {
      default: T(() => [
        v("div", {
          class: "hobi-slider",
          style: A(t.cssVariable),
          ref: "slider",
          onTouchstart: e[0] || (e[0] = (...l) => t.touchStart && t.touchStart(...l)),
          onTouchmove: e[1] || (e[1] = (...l) => t.touchMove && t.touchMove(...l)),
          onTouchend: e[2] || (e[2] = (...l) => t.touchEnd && t.touchEnd(...l))
        }, [
          v("div", {
            class: E(["hobi-slider__slide-list", {
              "hobi-slider__slide-list--with-margin": t.withMarginOnSlides,
              "hobi-slider__slide-list--with-margin-on-first-and-last": t.showMarginOnFirstAndLastTile
            }]),
            ref: "slideList"
          }, [
            I(t.$slots, "default", {}, void 0, !0)
          ], 2)
        ], 36)
      ]),
      _: 3
    }, 8, ["show-left-arrow", "show-right-arrow", "navigationArrowsAriaLabel"]),
    t.showPaginator ? (c(), L(o, {
      key: 0,
      slidesCount: t.numberOfSlides,
      activeIndex: t.activeIndex,
      "onSliderPaginator:click": t.handlePaginatorClick
    }, null, 8, ["slidesCount", "activeIndex", "onSliderPaginator:click"])) : S("", !0)
  ]);
}
const z = /* @__PURE__ */ V(M, [["render", y], ["__scopeId", "data-v-dd42691a"]]);
export {
  z as default
};
